import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import WikiArticle from './WikiArticle';
import articles from './articles';

const WikiPage = () => {
  const { slug } = useParams();
  const article = articles.find(a => a.slug === slug);

  if (!article) {
    return <Navigate to="/wiki" replace />;
  }

  const { content, ...metadata } = article;

  return (
    <WikiArticle 
      content={content} 
      metadata={metadata}
    />
  );
};

export default WikiPage; 